module.exports = __webpack_public_path__ + "img/科媒.75c9dd7e.png";